<template>
  <transition name="fade">
    <div v-if="show" style="margin-top:12px;">
      <div class="col-md-3 col-sm-3 col-xs-2">

      </div>
      <div class="col-md-21 col-sm-21 col-xs-21 nopadding" style="">

        <!--
          <p>
            <font-awesome-icon icon="envelope" class="red icon ddv" style="color: #c51a1b;" /> <a>{{dealer.email1}}</a>
          </p>
        -->
          <p>
            <font-awesome-icon icon="phone" class="red icon ddv" style="color: #c51a1b; margin-left: -6px;" />  <a v-bind:href="'tel:' + dealer.telefon1">{{dealer.telefon1}}</a>
          </p>
          <!--
          <p v-if="dealer.homepage">
            <font-awesome-icon icon="globe" class="red icon ddv" style="color: #c51a1b;" /> <a v-bind:href="'https://' + dealer.homepage" target="_blank">{{dealer.homepage}}</a>
          </p>
          -->
          <!--
          <p v-if="dealer.fahrzeuganzahl>0">
            <font-awesome-icon icon="arrow-right" class="red icon ddv" style="color: #c51a1b;" /> <a v-bind:href="vehiclesearchpath + '/#/d/' + dealer.uid" target="_blank">{{$t('Fahrzeugangebot des Händlers')}}</a>
          </p>
-->
          <!--
          <p v-if="dealer.email1">
            <font-awesome-icon icon="envelope" class="red icon ddv" style="color: #c51a1b;" /> <a @click="openEmailForm()" >{{$t('Nachricht senden')}}</a>
          </p>
          -->

          <p>
          </p>
          <!--
          <p v-if="dealer.email1">
            <br>
            <button class="ui red basic button"  style="margin-left:8px;" @click="openEmailForm()"><i class="ui icon" style="opacity: 1;"><font-awesome-icon icon="envelope" style="color: #c51a1b;;" /></i>Nachricht senden</button>
          </p>
        -->


      </div>


  </div>
  </transition>
</template>

<script>

export default {
  name: 'DealerInfo',
  props: ['dealer','show','index','vehiclesearchpath'],
  data: function() {
    return {
      body: "",
      disabled: true,
      imageUrl: null,
    }
  },
  components: {

  },
  created: function() {
  },
  beforeDestroy () {
  },
  methods: {

    inViewport: function (e) {

    },
    openEmailForm: function(){
      this.$emit('openEmailForm', this.dealer);
    }
  }
}
</script>

<style scoped>

.ddv{
  min-width: 30px;
}
.fade-enter-active{
  transition: opacity .0s;
}

.fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.raute p {
    width: 100%;
    text-align: center;
    line-height: 32px;
    color: white;
}

.more{
  width: 100%;
  text-align: center;
}
.dealeritem{
  border-bottom: 1px solid rgba(34,36,38,.15);
  padding-bottom: 20px;
  margin-bottom: 20px;
}
</style>
